import { setTheme } from "theme/default/setTheme";

export const setBackgroundColor_3a8fda = setTheme(({ theme }) => `background-color: ${theme.colors.color_3a8fda}`);
